import {
  loadAccountById,
  loadServicesByAccount,
  getFreeDomainAvailable,
  loadEmailsByAccount,
  loadAgentEventsByAccount,
  loadLoginEventsByAccount,
  loadUberSmithEventsByUberClientId,
  loadSdnEventsByAccount,
  loadPasswordResetEventsByAccount,
  loadCommentsByAccount,
  loadUbersmithComments,
  getGoodwillCreditsForAccount
} from '../store/actions'

import { getInvoices } from '../store/account/billing-tab/actions'
import { loadDomainsByAccount } from '../store/account/shared/actions'
import { loadSitesByAccount } from '../store/account/sites-tab/actions'

export const refreshContent = (location, account, dispatch) => {
  dispatch(loadAccountById(account.partnerId, account.id))
  dispatch(getGoodwillCreditsForAccount(account.id, account.partnerId))

  if (location.pathname.includes('sites')) {
    dispatch(loadSitesByAccount(account.id, account.partnerId))
  } else if (location.pathname.includes('services')) {
    dispatch(loadServicesByAccount(account.id, account.partnerId))
  } else if (location.pathname.includes('domains')) {
    dispatch(loadDomainsByAccount(account.id, account.partnerId))
    dispatch(getFreeDomainAvailable(account.id, account.partnerId))
  } else if (location.pathname.includes('mail')) {
    dispatch(loadEmailsByAccount(account.id, account.partnerId))
  } else if (location.pathname.includes('events')) {
    dispatch(loadAgentEventsByAccount(account.partnerId, account.id))
    dispatch(loadLoginEventsByAccount(account.partnerId, account.id))
    dispatch(loadUberSmithEventsByUberClientId(account.partnerId, account.id, account.uberClientId))
    dispatch(loadSdnEventsByAccount(account.partnerId, account.id))
    dispatch(loadPasswordResetEventsByAccount(account.partnerId, account.id))
  } else if (location.pathname.includes('comments')) {
    dispatch(loadCommentsByAccount(account.partnerId, account.id))
    dispatch(loadUbersmithComments(account.partnerId, account.id, account.uberClientId))
  } else if (location.pathname.includes('billing')) {
    dispatch(getInvoices(account.id, account.partnerId))
  }
}
